// config.js

const config = {
    // apiUrl: 'https://api.riam.servermdz.com',

    // apiUrl: 'http://152.228.217.114:10002',
    // path: 'http://152.228.217.114',

    apiUrl: 'http://152.228.217.114:10002',
    path: 'http://152.228.217.114',

    // apiUrl: 'http://192.168.8.127:10002',
    // path: 'http://192.168.8.127',

    wsUrl : "ws://localhost:8081/ws",
    apiKey: '53666584f14702461b417a3b431278471be4c1f82edd7a385c1c01c4',
  };
  
  export default config;